import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { useLocation } from 'react-router-dom';
import { BreadcrumbText } from './BreadcrumbText';
import * as Utility from '../utility';

export const BreadcrumbContext = React.createContext({});
import { Flex, Icon, icons } from '@tapresearch/ui/components';

const INITIAL_BREADCRUMS = [
  {
    content: (
      <BreadcrumbText>
        <Flex align="center">
          <Icon
            mr={1}
            boxSize={5}
            color="gray.300"
            icon={icons.fi.ChevronLeft}
          />
          Return to projects
        </Flex>
      </BreadcrumbText>
    ),
    linkProps: {
      as: Link,
      to: `/`,
    },
  },
];

export const BreadcrumbProvider = ({ children }) => {
  let location = useLocation();
  const isProjectsSubRoute = !!Utility.useRouteMatch('/projects/*');
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [altContent, setAltContent] = useState(null);

  useEffect(() => {
    if (!isProjectsSubRoute) {
      setBreadcrumb([]);
      setAltContent(null);
    }
  }, [isProjectsSubRoute, location]);

  return (
    <BreadcrumbContext.Provider
      value={{
        breadcrumb,
        setBreadcrumb,
        INITIAL_BREADCRUMS,
        altContent,
        setAltContent,
      }}
    >
      {children}
    </BreadcrumbContext.Provider>
  );
};
